import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { CheckCircleOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import SectionContainer from '../components/SectionContainer';
import RevealOnScroll from '../components/RevealOnScroll';

const PRICING_POINTS = [
  'No setup fee — list your library for free, forever.',
  '5% commission only on successful online bookings — nothing on offline collections.',
  'Weekly payouts every Monday, straight to your bank account via NEFT.',
];

function PricingSection() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const orange = theme.palette.brand.orange.main;
  const golden = theme.palette.brand.golden.main;

  const cardBg = isDark ? 'rgba(27,54,93,0.6)' : theme.palette.background.paper;
  const cardBorder = isDark
    ? '1px solid rgba(255,255,255,0.08)'
    : '1px solid rgba(27,54,93,0.08)';

  const handleScrollToSignup = () => {
    const el = document.getElementById('signup');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <SectionContainer
      id="pricing"
      eyebrow="Commercials"
      title="Free to list. Pay only when you earn."
      subtitle="No upfront costs. No monthly fees. We only succeed when you do."
      sx={{
        background: isDark
          ? `rgba(255,255,255,0.01)`
          : `rgba(242,101,34,0.02)`,
      }}
    >
      <RevealOnScroll>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            p: { xs: 4, md: 6 },
            borderRadius: '24px',
            background: cardBg,
            border: cardBorder,
            boxShadow: isDark
              ? '0 8px 40px rgba(0,0,0,0.3)'
              : '0 8px 40px rgba(27,54,93,0.1)',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 4 }}>
            {PRICING_POINTS.map((point) => (
              <Box key={point} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <CheckCircleOutlined
                  sx={{
                    color: orange,
                    fontSize: 24,
                    flexShrink: 0,
                    mt: 0.1,
                  }}
                />
                <Typography variant="body1" sx={{ color: 'text.primary', lineHeight: 1.6 }}>
                  {point}
                </Typography>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleScrollToSignup}
            sx={{
              background: `linear-gradient(135deg, ${orange}, ${golden})`,
              color: '#fff',
              fontWeight: 700,
              py: 1.75,
              fontSize: '1rem',
              borderRadius: 3,
              boxShadow: '0 8px 24px rgba(242,101,34,0.35)',
              '&:hover': {
                background: `linear-gradient(135deg, ${theme.palette.brand.orange.light}, ${orange})`,
                boxShadow: '0 12px 32px rgba(242,101,34,0.45)',
                transform: 'translateY(-1px)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            Start listing your library
          </Button>
        </Box>
      </RevealOnScroll>
    </SectionContainer>
  );
}

export default PricingSection;
